import { BtnLoadingResetEvent } from './btn-loading';
import { checkIfUserIsLoggedIn, dataURItoBlob } from '../utils/utils';
import { getData, postData } from '../utils/ajax-utils';

export function initConfigurateOrderStep5() : void {
    document.querySelectorAll<HTMLElement>('.js-configurate-order-step-5').forEach($module => {
        new ConfigurateOrderStep5($module);
    });
}

class ConfigurateOrderStep5 {
    $container: HTMLElement;
    $dlCertifFormattedSelectFields: NodeListOf<HTMLSelectElement>;
    $p12PasswordForm: NodeListOf<HTMLFormElement>;
    $downloadCertificateCaForm: NodeListOf<HTMLFormElement>;
    $isIssueInProgress: HTMLElement|null;
    $revocationOtpForm: HTMLElement|null;
    $revocationOtpFormFieldsContainer: HTMLElement|null = null;
    $revocationOtpFormFields: NodeListOf<HTMLInputElement>|null = null;
    $collectPinOtpForm: HTMLElement|null;
    $collectPinOtpFormFieldsContainer: HTMLElement|null = null;
    $collectPinOtpFormFields: NodeListOf<HTMLInputElement>|null = null;

    constructor($container: HTMLElement) {
        this.$container = $container;
        this.$dlCertifFormattedSelectFields = this.$container.querySelectorAll<HTMLSelectElement>('select.download_certificat_formatted');

        this.$dlCertifFormattedSelectFields.forEach($dlCertifFormattedFields => {
            $dlCertifFormattedFields.addEventListener('change', evt => this.dlCertifFormattedFields(evt));
        });

        // Si p12 stocké en localStorage, il est téléchargé puis supprimé
        if (localStorage.getItem('p12_file')) {
            const blob = dataURItoBlob(localStorage.getItem('p12_file') || '');
            const $a = document.createElement('a');
            const url = window.URL.createObjectURL(blob);
            $a.style.display = 'none';
            $a.href = url;
            $a.download = 'certificat.p12';
            document.body.appendChild($a);
            localStorage.removeItem('p12_file');
            $a.click();
        }

        // Formulaire P12 Password soumis ?
        this.$p12PasswordForm = this.$container.querySelectorAll<HTMLFormElement>('form[name="p12_form"]');

        this.$p12PasswordForm.forEach($p12PasswordForm => {
            const $p12PasswordFormInput1 = $p12PasswordForm.querySelector('input[name="p12_form[password][first]"]') as HTMLInputElement;
            const $p12PasswordFormInput2 = $p12PasswordForm.querySelector('input[name="p12_form[password][second]"]') as HTMLInputElement;
            const $p12PasswordFormInput1ErrorContainer = $p12PasswordForm.querySelector('.p12-form-password-first-error') as HTMLElement;
            const $p12PasswordFormSubmitBtn = $p12PasswordForm.querySelector('[type="submit"]') as HTMLButtonElement;
            const p12PasswordFormInputMinLength = parseInt($p12PasswordFormInput1.dataset.min || '0');
            const p12PasswordFormInputRegex = new RegExp($p12PasswordFormInput1.dataset.regex as string);
            const p12PasswordFormInputLengthError = $p12PasswordFormInput1.dataset.errorLength;
            const p12PasswordFormInputRegexError = $p12PasswordFormInput1.dataset.errorRegex;
            const p12PasswordFormInputMatchError = $p12PasswordFormInput1.dataset.errorMatch;

            $p12PasswordForm.addEventListener('submit', evt => {
                evt.preventDefault();

                checkIfUserIsLoggedIn().then(userIsLoggedIn => {
                    if (!userIsLoggedIn) {
                        // Redirect to login page
                        window.location.href = scriptVar.loginUrl + '?referrer=' + window.location.href;
                        return;
                    }

                    // Validation JS sur la base de la validation TWIG
                    let errorMessage = null;
                    if ($p12PasswordFormInput1.value.length < p12PasswordFormInputMinLength) {
                        errorMessage = p12PasswordFormInputLengthError;
                    } else if (!p12PasswordFormInputRegex.test($p12PasswordFormInput1.value)) {
                        errorMessage = p12PasswordFormInputRegexError;
                    } else if ($p12PasswordFormInput1.value !== $p12PasswordFormInput2.value) {
                        errorMessage = p12PasswordFormInputMatchError;
                    }

                    $p12PasswordFormInput1ErrorContainer.innerHTML = '';
                    if (errorMessage) {
                        const $error = document.createElement('li');
                        $error.innerText = errorMessage;
                        $p12PasswordFormInput1ErrorContainer.appendChild($error);

                        // Reset the loading state
                        $p12PasswordFormSubmitBtn.dispatchEvent(BtnLoadingResetEvent);
                        return;
                    }

                    const $errorFileDownloadElement = document.querySelector<HTMLElement>('.error-file-download');
                    const urlParams = new URLSearchParams(window.location.search);
                    const args = {
                        action: 'get_p12_certificate',
                        order: urlParams.get('order') || '',
                        password: $p12PasswordFormInput1.value,
                    };

                    postData(scriptVar.ajaxUrl, args)
                        .then(resp => {
                            if ('undefined' !== typeof resp.success && !resp.success) {
                                throw Error;
                            }

                            return resp.blob();
                        })
                        .then(blob => {
                            const reader = new FileReader();
                            reader.onload = (event) => {
                                localStorage.setItem('p12_file', (event.target as any).result);
                            };
                            
                            reader.readAsDataURL(blob);

                            window.location.href = window.location.origin + window.location.pathname +
                                '?order=' + urlParams.get('order');
                        })
                        .catch(function() {
                            $errorFileDownloadElement?.classList.remove('hidden');
                            $p12PasswordFormSubmitBtn.dispatchEvent(BtnLoadingResetEvent);
                        });
                });
            });
        });

        // Formulaire Certificat CA soumis ?
        this.$downloadCertificateCaForm = this.$container.querySelectorAll<HTMLFormElement>('form[name="download_certificate_ca_form"]');

        this.$downloadCertificateCaForm.forEach($downloadCertificateCaForm => {
            $downloadCertificateCaForm.addEventListener('submit', evt => {
                evt.preventDefault();

                const $form = $downloadCertificateCaForm;
                
                const $button = $form.querySelector<HTMLButtonElement>('button');

                // Empêche les clicks multiples
                if ($button?.classList.contains('wait')) {
                    return;
                }

                $button?.classList.add('wait');

                checkIfUserIsLoggedIn().then(userIsLoggedIn => {
                    if (!userIsLoggedIn) {
                        // Redirect to login page
                        window.location.href = scriptVar.loginUrl + '?referrer=' + window.location.href;
                        return;
                    }

                    const fetchUrl = window.location.href;
                    const filename = ($form.querySelector('input[name="download_certificate_ca_form[filename]"]') as HTMLInputElement).value;
                    const formData = new FormData();
                    const $errorFileDownloadElement = document.querySelector<HTMLElement>('.error-file-download');

                    formData.append('download_certificate_ca_form[filename]', filename);

                    postData(fetchUrl, formData)
                        .then(resp => {
                            if ('undefined' !== typeof resp.success && !resp.success) {
                                throw Error;
                            }
        
                            return resp.blob();
                        })
                        .then(blob => {
                            $button?.classList.remove('wait');
                            
                            const url = window.URL.createObjectURL(blob);
                            const $a = document.createElement('a');
                            $a.style.display = 'none';
                            $a.href = url;
                            $a.download = filename;
                            document.body.appendChild($a);
                            $a.click();
                            window.URL.revokeObjectURL(url);
                            $errorFileDownloadElement?.classList.add('hidden');
                        })
                        .catch(() => {
                            $errorFileDownloadElement?.classList.remove('hidden');
                            $button?.classList.remove('wait');
                        });
                });
            });
        });

        // Emission du certificat en cours ?
        this.$isIssueInProgress = this.$container.querySelector<HTMLElement>('.configurate-order-main-content.issue-in-progress');
        let $checkIssuance: number;
        
        if (this.$isIssueInProgress) {
            $checkIssuance = setInterval(() => {
                const urlParams = new URLSearchParams(window.location.search);
                getData(scriptVar.ajaxUrl, {
                    action: 'get_order_statut',
                    order: urlParams.get('order') || '',
                }).then(response => {
                    switch (response.data.result) {
                        case 'issued':
                        case 'error':
                            clearInterval($checkIssuance);
                            document.location.reload();
                            break;
                    }
                });
            }, 10000);
        }

        // Révocation du certificat -> Récupération du code de déblocage par OTP
        this.$revocationOtpForm = this.$container.querySelector<HTMLElement>('.js-revocation-otp-form');
        if (this.$revocationOtpForm) {
            this.$revocationOtpFormFieldsContainer = this.$revocationOtpForm.querySelector<HTMLElement>('.js-phone-otp-module-verification-fields');
            this.$revocationOtpFormFields = this.$revocationOtpFormFieldsContainer?.querySelectorAll<HTMLInputElement>('.js-phone-otp-module-verification-field') || null;

            if (this.$revocationOtpFormFieldsContainer) {
                this.$revocationOtpFormFieldsContainer.addEventListener('keyup', evt => this.onRevocationOtpFormVerificationFieldsKeyUp(evt));
            }
        }

        // Récupération du code de déblocage du certificat -> Récupération du code de déblocage par OTP
        this.$collectPinOtpForm = this.$container.querySelector<HTMLElement>('.js-collect-pin-otp-form');
        if (this.$collectPinOtpForm) {
            this.$collectPinOtpFormFieldsContainer = this.$collectPinOtpForm.querySelector<HTMLElement>('.js-phone-otp-module-verification-fields');
            this.$collectPinOtpFormFields = this.$collectPinOtpFormFieldsContainer?.querySelectorAll<HTMLInputElement>('.js-phone-otp-module-verification-field') || null;

            if (this.$collectPinOtpFormFieldsContainer) {
                this.$collectPinOtpFormFieldsContainer.addEventListener('keyup', evt => this.onCollectPinOtpFormVerificationFieldsKeyUp(evt));
            }
        }

        // Enable/disable certificate sharing with CLM partners
        this.$container.querySelectorAll<HTMLElement>('.js-clm-partner-enable-certificate-sharing').forEach($clmPartnerContainer => {
            const partnerName = $clmPartnerContainer.dataset.partnerName;
            const orderRefExt = $clmPartnerContainer.dataset.orderRefExt;
            const $input = $clmPartnerContainer.querySelector<HTMLInputElement>('input');
            const enabledMessage = $clmPartnerContainer.dataset.enableMessage;
            const disabledMessage = $clmPartnerContainer.dataset.disableMessage;
            const errorMessage = $clmPartnerContainer.dataset.errorMessage;

            $clmPartnerContainer.removeAttribute('data-partner-name');
            $clmPartnerContainer.removeAttribute('data-order-ref-ext');
            $clmPartnerContainer.removeAttribute('data-enable-message');
            $clmPartnerContainer.removeAttribute('data-disable-message');
            $clmPartnerContainer.removeAttribute('data-error-message');

            if (!partnerName || !orderRefExt || !$input) {
                return;
            }

            let toEnable = !$input.checked;

            $input.addEventListener('click', evt => {
                evt.preventDefault();
                $clmPartnerContainer.classList.add('wait');

                postData(scriptVar.ajaxUrl, {
                    action: 'change_clm_partner_certificate_sharing',
                    partner_name: partnerName,
                    order_ref_ext: orderRefExt,
                    to_enable: toEnable.toString(),
                }).then(response => {
                    if (response.success) {
                        $input.checked = toEnable;

                        if ((toEnable && enabledMessage) || (!toEnable && disabledMessage)) {
                            document.dispatchEvent(new CustomEvent('add_flash', {
                                detail: {
                                    type: 'success',
                                    message: toEnable ? enabledMessage : disabledMessage,
                                },
                            }));
                        }
                    } else if (errorMessage) {
                        document.dispatchEvent(new CustomEvent('add_flash', {
                            detail: {
                                type: 'danger',
                                message: errorMessage,
                            },
                        }));
                    }

                    toEnable = !toEnable;
                    $clmPartnerContainer.classList.remove('wait');
                }).catch(() => {
                    $clmPartnerContainer.classList.remove('wait');

                    if (errorMessage) {
                        document.dispatchEvent(new CustomEvent('add_flash', {
                            detail: {
                                type: 'danger',
                                message: errorMessage,
                            },
                        }));
                    }
                });
            });
        });
    }

    /**
     * Format the verification fields inputs
     * 
     * @param {KeyboardEvent} evt
     * 
     * @return {void}
     */
    onRevocationOtpFormVerificationFieldsKeyUp(evt: KeyboardEvent) : void {
        const $target = evt.target as HTMLInputElement;

        if ($target.classList.contains('js-phone-otp-module-verification-field')) {
            if ('Backspace' === evt.key) {
                const index = parseInt(($target.getAttribute('id') || '').slice(-1));
                const newIndex = index - 1;
                const $previousField = this.$revocationOtpFormFields ? this.$revocationOtpFormFields[newIndex - 1] : undefined;
                if (typeof $previousField !== 'undefined') {
                    $previousField.focus();
                }
            } else if (/^[a-zA-Z0-9]{1}$/.test(evt.key)) {
                $target.value = evt.key.toUpperCase();

                const index = parseInt(($target.getAttribute('id') || '').slice(-1));
                const newIndex = index + 1;
                const $nextField = this.$revocationOtpFormFields ? this.$revocationOtpFormFields[newIndex - 1] : undefined;
                if (typeof $nextField !== 'undefined') {
                    $nextField.focus();
                }

                this.checkRevocationOtpFormVerificationFields();
            } else if (/^[a-zA-Z0-9]{1}$/.test($target.value.slice(0, 1))) {
                if (5 === $target.value.length) {
                    const value = $target.value;
                    this.$revocationOtpFormFields?.forEach(($verificationField, index) => {
                        $verificationField.value = value.slice(index, index + 1);
                        if (4 === index) {
                            $verificationField.focus();
                        }
                    });

                    this.checkRevocationOtpFormVerificationFields();
                } else {
                    $target.value = $target.value.slice(0, 1);
                }
            } else {
                $target.value = '';
            }
        }
    }

    /**
     * Verify verification fields inputs and validate the OTP code typped
     * 
     * @return {void}
     */
    checkRevocationOtpFormVerificationFields() : void {
        let fieldsFilled = 0;
        this.$revocationOtpFormFields?.forEach($verificationField => {
            if ('' !== $verificationField.value) {
                fieldsFilled++;
            }
        });

        if (fieldsFilled === this.$revocationOtpFormFields?.length) {
            this.$revocationOtpForm?.querySelector<HTMLButtonElement>('.js-revocation-otp-form-submit')?.click();
        }
    }

    /**
     * Format the verification fields inputs
     * 
     * @param {KeyboardEvent} evt
     */
    onCollectPinOtpFormVerificationFieldsKeyUp(evt: KeyboardEvent) : void {
        const $target = evt.target as HTMLInputElement;
        if ($target.classList.contains('js-phone-otp-module-verification-field')) {
            if ('Backspace' === evt.key) {
                const index = parseInt(($target.getAttribute('id') || '').slice(-1));
                const newIndex = index - 1;
                const $previousField = this.$collectPinOtpFormFields ? this.$collectPinOtpFormFields[newIndex - 1] : undefined;
                if (typeof $previousField !== 'undefined') {
                    $previousField.focus();
                }
            } else if (/^[a-zA-Z0-9]{1}$/.test(evt.key)) {
                $target.value = evt.key.toUpperCase();

                const index = parseInt(($target.getAttribute('id') || '').slice(-1));
                const newIndex = index + 1;
                const $nextField = this.$collectPinOtpFormFields ? this.$collectPinOtpFormFields[newIndex - 1] : undefined;
                if (typeof $nextField !== 'undefined') {
                    $nextField.focus();
                }

                this.checkCollectPinOtpFormVerificationFields();
            } else if (/^[a-zA-Z0-9]{1}$/.test($target.value.slice(0, 1))) {
                if (5 === $target.value.length) {
                    const value = $target.value;
                    this.$collectPinOtpFormFields?.forEach(($verificationField, index) => {
                        $verificationField.value = value.slice(index, index + 1);
                        if (4 === index) {
                            $verificationField.focus();
                        }
                    });

                    this.checkCollectPinOtpFormVerificationFields();
                } else {
                    $target.value = $target.value.slice(0, 1);
                }
            } else {
                $target.value = '';
            }
        }
    }

    /**
     * Verify verification fields inputs and validate the OTP code typped
     * 
     * @return {void}
     */
    checkCollectPinOtpFormVerificationFields() : void {
        let fieldsFilled = 0;
        this.$collectPinOtpFormFields?.forEach($verificationField => {
            if ('' !== $verificationField.value) {
                fieldsFilled++;
            }
        });

        if (fieldsFilled === this.$collectPinOtpFormFields?.length) {
            this.$collectPinOtpForm?.querySelector<HTMLButtonElement>('.js-collect-pin-otp-form-submit')?.click();
            this.$collectPinOtpForm?.querySelector<HTMLButtonElement>('.js-collect-pin-otp-form-submit')?.setAttribute('disabled', 'true');
            this.$collectPinOtpForm?.querySelector<HTMLButtonElement>('.js-collect-pin-otp-form-resend')?.setAttribute('disabled', 'true');
        }
    }

    /**
     * Submit Form on change
     * 
     * @param {Event} evt
     */
    dlCertifFormattedFields(evt: Event) : void {
        const $button = evt.target as HTMLButtonElement;
        const $form = $button.closest('form');
        
        if ('' === $button.value) {
            return;
        }

        $button.classList.add('wait');

        checkIfUserIsLoggedIn().then(userIsLoggedIn => {
            if (!userIsLoggedIn) {
                // Redirect to login page
                window.location.href = scriptVar.loginUrl + '?referrer=' + window.location.href;
                return;
            }

            const fetchUrl = window.location.href;
            const filename = $form?.querySelector<HTMLInputElement>('input[name="download_certificate_form[filename_' + $button.value + ']"]')?.value || '';
            const formData = new FormData();
            const $errorFileDownloadElement = document.querySelector<HTMLElement>('.error-file-download');
            formData.append('download_certificate_form[download_format]', $button.value);
            
            postData(fetchUrl, formData)
                .then(resp => {
                    if ('undefined' !== typeof resp.success && !resp.success) {
                        throw Error;
                    }

                    return resp.blob();
                })
                .then(blob => {
                    $button.classList.remove('wait');
                    
                    const url = window.URL.createObjectURL(blob);
                    const $a = document.createElement('a');
                    $a.style.display = 'none';
                    $a.href = url;
                    $a.download = filename;
                    document.body.appendChild($a);
                    $a.click();
                    window.URL.revokeObjectURL(url);
                    $errorFileDownloadElement?.classList.add('hidden');
                })
                .catch(() => {
                    $errorFileDownloadElement?.classList.remove('hidden');
                    $button.classList.remove('wait');
                });

            $button.setAttribute('selected-index', '0');
        });
    }
}
